export const Categories = [
  {
    id: 'coding',
    label: 'Coding',
    parentLabel: 'Detailed 4Cs feedback',
    imgSrc: 'https://assets.languify.in/images/elementTag.png',
    score: 1,
    description: 'Ability to write clean, efficient, and logically sound code that handles edge cases and uses appropriate data structures',
    subCategories: [
      {
        id: 'DSA_USAGE_AND_UNDERSTANDING',
        label: 'DSA Usage & Understanding',
        score: 1,
        weightage: 44.44,
        description: 'Appropriate selection and implementation of data structures and algorithms, emphasizing efficient operations such as lookup, access, and overall performance'
      },
      {
        id: 'EDGE_CASE_HANDLING',
        label: 'Edge Case Handling',
        score: 1,
        weightage: 11.11,
        description: 'Effective management of constraints by addressing boundary conditions, handling empty inputs, and accounting for atypical or unexpected values'
      },
      {
        id: 'CODE_ORGANIZATION_AND_CLARITY',
        label: 'Code Organization & Clarity',
        score: 1,
        weightage: 11.11,
        description: 'Clarity and readability of the code through structured modularity, appropriate function separation, optimized loop nesting, and code reuse'
      },
      {
        id: 'SCALABILITY_AND_EFFICIENCY',
        label: 'Scalability & Efficiency',
        score: 1,
        weightage: 33.33,
        description: 'Solution performance in terms of time and space complexity, particularly in its ability to scale with larger input sizes.'
      },
    ]
  },
  {
    id: 'coreConcepts',
    label: 'Core Concepts',
    imgSrc: 'https://assets.languify.in/images/coreConcepts.png',
    score: 1,
    description: 'Depth of understanding and accurate application of foundational computer science principles',
    subCategories: [
      {
        id: 'CONCEPTUAL_CLARITY',
        label: 'Conceptual Clarity',
        score: 1,
        weightage: 100,
        description: 'Demonstration of a strong grasp of the underlying algorithmic principles through clear, logical, and step-by-step implementation'
      },
    ]
  },
  {
    id: 'criticalThinking',
    label: 'Critical Thinking',
    imgSrc: 'https://assets.languify.in/images/criticalThinking.png',
    score: 1,
    description: 'Skill in analyzing problems, adapting solutions, and applying logical reasoning under constraints',
    subCategories: [
      {
        id: 'LOGICAL_REASONING_AND_ANALYSIS',
        label: 'Logical Reasoning & Analysis',
        score: 1,
        weightage: 50,
        description: 'The ability to logically deconstruct the problem and devise a step-by-step, efficient solution while considering all the given constraints'
      },
      {
        id: 'ADAPTIVE_IMPROVEMENT',
        label: 'Adaptive Improvement',
        score: 1,
        weightage: 50,
        description: 'The ability to iteratively refine and optimize the initial solution based on feedback or new inputs through follow-up questions, reflecting independent problem-solving and responsiveness'
      },
    ]
  },
  {
    id: 'content',
    label: 'Content',
    parentLabel: 'Communication Skills',
    imgSrc: 'https://assets.languify.in/images/content4c.png',
    score: 1,
    description: 'Clarity and coherence in explaining thought processes, logic, and decision-making during problem-solving',
    subCategories: [
      {
        id: 'EXPLANATION_AND_LOGICAL_COHERENCE',
        label: 'Explanation & Logical Coherence',
        score: 1,
        weightage: 100,
        description: 'Ensures the explanation aligns with the implemented code, with clear justification for design and logic decisions'
      },
    ]
  },
  {
    id: 'speech',
    label: 'Speech',
    imgSrc: 'https://assets.languify.in/images/speech4c.png',
    score: 1,
    description: 'Ability to articulate thoughts clearly and effectively',
    subCategories: [
      {
        id: 'FLUENCY',
        label: 'Fluency',
        score: 1,
        weightage: 50,
        description: 'Ability to speak smoothly, with clear, continuous flow, and minimal pauses or disruptions'
      },
      {
        id: 'DELIVERY',
        label: 'Delivery',
        score: 1,
        weightage: 50,
        description: 'How someone talks, focusing on how fast they speak & their energy level'
      },
    ]
  },
];

export const SubCategoryWeightages = [
  {
    subCategory: "LOGICAL_REASONING_AND_ANALYSIS",
    weightage: 20
  },
  {
    subCategory: "EDGE_CASE_HANDLING",
    weightage: 5
  },
  {
    subCategory: "CODE_ORGANIZATION_AND_CLARITY",
    weightage: 5
  },
  {
    subCategory: "DSA_USAGE_AND_UNDERSTANDING",
    weightage: 20
  },
  {
    subCategory: "CONCEPTUAL_CLARITY",
    weightage: 15
  },
  {
    subCategory: "EXPLANATION_AND_LOGICAL_COHERENCE",
    weightage: 5
  },
  {
    subCategory: "SCALABILITY_AND_EFFICIENCY",
    weightage: 15
  },
  {
    subCategory: "ADAPTIVE_IMPROVEMENT",
    weightage: 15
  },
];

export const CodeComplexity = {
  "idealTimeComplexity": "Ideal time complexity",
  "userTimeComplexity": "User time complexity",
  "idealSpaceComplexity": "Ideal space complexity",
  "userSpaceComplexity": "User space complexity",
  "followup1TimeComplexity": "Followup 1 time complexity",
  "followup2TimeComplexity": "Followup 2 time complexity"
};

export const CodingLanguagesMap = {
  "104": {
    "name": "C (Clang 18.1.8)",
    "code": "c",
    "id": 104
  },
  "110": {
    "name": "C (Clang 19.1.7)",
    "code": "c",
    "id": 110
  },
  "75": {
    "name": "C (Clang 7.0.1)",
    "code": "c",
    "id": 75
  },
  "103": {
    "name": "C (GCC 14.1.0)",
    "code": "c",
    "id": 103
  },
  "48": {
    "name": "C (GCC 7.4.0)",
    "code": "c",
    "id": 48
  },
  "49": {
    "name": "C (GCC 8.3.0)",
    "code": "c",
    "id": 49
  },
  "50": {
    "name": "C (GCC 9.2.0)",
    "code": "c",
    "id": 50
  },
  "79": {
    "name": "Objective-C (Clang 7.0.1)",
    "code": "c",
    "id": 79
  },
  "105": {
    "name": "C++ (GCC 14.1.0)",
    "code": "c++",
    "id": 105
  },
  "76": {
    "name": "C++ (Clang 7.0.1)",
    "code": "c++",
    "id": 76
  },
  "52": {
    "name": "C++ (GCC 7.4.0)",
    "code": "c++",
    "id": 52
  },
  "53": {
    "name": "C++ (GCC 8.3.0)",
    "code": "c++",
    "id": 53
  },
  "54": {
    "name": "C++ (GCC 9.2.0)",
    "code": "c++",
    "id": 54
  },
  "60": {
    "name": "Go (1.13.5)",
    "code": "go",
    "id": 60
  },
  "95": {
    "name": "Go (1.18.5)",
    "code": "go",
    "id": 95
  },
  "106": {
    "name": "Go (1.22.0)",
    "code": "go",
    "id": 106
  },
  "107": {
    "name": "Go (1.23.5)",
    "code": "go",
    "id": 107
  },
  "96": {
    "name": "JavaFX (JDK 17.0.6, OpenJFX 22.0.2)",
    "code": "java",
    "id": 96
  },
  "91": {
    "name": "Java (JDK 17.0.6)",
    "code": "java",
    "id": 91
  },
  "62": {
    "name": "Java (OpenJDK 13.0.1)",
    "code": "java",
    "id": 62
  },
  "63": {
    "name": "JavaScript (Node.js 12.14.0)",
    "code": "javascript",
    "id": 63
  },
  "93": {
    "name": "JavaScript (Node.js 18.15.0)",
    "code": "javascript",
    "id": 93
  },
  "97": {
    "name": "JavaScript (Node.js 20.17.0)",
    "code": "javascript",
    "id": 97
  },
  "102": {
    "name": "JavaScript (Node.js 22.08.0)",
    "code": "javascript",
    "id": 102
  },
  "78": {
    "name": "Kotlin (1.3.70)",
    "code": "kotlin",
    "id": 78
  },
  "111": {
    "name": "Kotlin (2.1.10)",
    "code": "kotlin",
    "id": 111
  },
  "70": {
    "name": "Python (2.7.17)",
    "code": "python",
    "id": 70
  },
  "92": {
    "name": "Python (3.11.2)",
    "code": "python",
    "id": 92
  },
  "100": {
    "name": "Python (3.12.5)",
    "code": "python",
    "id": 100
  },
  "109": {
    "name": "Python (3.13.2)",
    "code": "python",
    "id": 109
  },
  "71": {
    "name": "Python (3.8.1)",
    "code": "python",
    "id": 71
  },
  "72": {
    "name": "Ruby (2.7.0)",
    "code": "ruby",
    "id": 72
  },
  "73": {
    "name": "Rust (1.40.0)",
    "code": "rust",
    "id": 73
  },
  "108": {
    "name": "Rust (1.85.0)",
    "code": "rust",
    "id": 108
  }
};